import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedCustomDate } from "components/common/FormattedComponents";
import UpArrow from "../../common/ArrowUp";
import DownArrow from "../../common/ArrowDown";
import messages from "components/messagesDescription";
import StandardMoney from "components/common/StandardMoney";

const AccountAccordion = ({
  intl,
  data: {
    accountName,
    planPeriodStart,
    planPeriodEnd,
    allocation,
    utilized,
    balance,
    pendingReceiptAmount,
    currency,
    isUnlimited,
  },
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = e => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <div className="claim-accordions">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#" onClick={toggleAccordion}>
        <table>
          <tr>
          <td style={{ width: "85%" }}>
              {intl.formatMessage({ id: accountName, defaultMessage: accountName })}
            </td>
            <td style={{ width: "15%",  textAlign:"right" }}>
              {isOpen ? (
                <UpArrow width="14px" height="14px" />
              ) : (
                <DownArrow width="16px" height="16px" />
              )}
            </td>
          </tr>
        </table>
      </a>
      {isOpen && (
        <div>
          <p>
            {intl.formatMessage(messages.claims.accounts.period)}: <br />
            <FormattedCustomDate value={planPeriodStart} /> -
            <FormattedCustomDate value={planPeriodEnd} />
          </p>

          <table>
            <tr>
              <td> {intl.formatMessage(messages.claims.accounts.allocation)}:</td>
              <td style={{ textAlign:"right" }}>
                <StandardMoney value={allocation} currency={currency} isUnlimited={isUnlimited} />
              </td>
            </tr>
            <tr>
              <td> {intl.formatMessage(messages.claims.accounts.utilized)}:</td>
              <td style={{ textAlign:"right" }}>
                {" "}
                <StandardMoney value={utilized} currency={currency} isUnlimited={isUnlimited} />
              </td>
            </tr>
          </table>
        </div>
      )}
      <table>
        <tr>
          <td>
            <strong> {intl.formatMessage(messages.claims.accounts.balance)}:</strong>
          </td>
          <td style={{ textAlign:"right", whiteSpace:"nowrap" }}>
            <strong>
              <StandardMoney
                value={balance}
                currency={currency}
                isUnlimited={isUnlimited}
              />
            </strong>
          </td>
        </tr>
        <tr>
          <td>{intl.formatMessage(messages.claims.accounts.pendingReceiptAmount)}:</td>
          <td style={{ textAlign:"right" }}>
            {" "}
            <StandardMoney
              value={pendingReceiptAmount}
              currency={currency}
              isUnlimited={isUnlimited}
            />
          </td>
        </tr>
      </table>
    </div>
  );
};

AccountAccordion.propTypes = {
  intl: PropTypes.object.isRequired,
  data: PropTypes.shape({
    accountName: PropTypes.string.isRequired,
    planPeriodStart: PropTypes.string.isRequired,
    planPeriodEnd: PropTypes.string.isRequired,
    allocation: PropTypes.number.isRequired,
    utilized: PropTypes.number.isRequired,
    balance: PropTypes.number.isRequired,
    pendingReceiptAmount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    isUnlimited: PropTypes.bool.isRequired,
  }).isRequired,
};

export default AccountAccordion;



// WEBPACK FOOTER //
// ./components/claim/widgets/AccountAccordion.js